import { whiteList } from 'xss';
import { kabebCase, ignoreElement, eachKey, vueUtils, decorateAttachShadow } from '../utils';
import { tagNameMap } from '../utils/common';
import Api from '../api/main';

try {
  for (var k in tagNameMap) {
    var _tagNameMap$k = tagNameMap[k],
        tag = _tagNameMap$k[0],
        openId = _tagNameMap$k[1],
        openType = _tagNameMap$k[2];
    whiteList[tag] = ['style', openId, openType];
  }

  for (var key in whiteList) {
    Object.hasOwnProperty.call(whiteList, key) && whiteList[key].push('style');
  }
} catch (e) {} // @ts-ignore


import DdOpenData from './dd-open-data'; // @ts-ignore

import OpenData from './open-data'; // @ts-ignore

import WwOpenData from './ww-open-data'; // @ts-ignore

import UserName from './user-name'; // @ts-ignore

import PositionName from './position-name'; // @ts-ignore

import DeptName from './dept-name'; // @ts-ignore

import OpenDataMatch from './open-data-match'; // @ts-ignore

import OpenDataHtml from './open-data-html';
var components = {
  DdOpenData: DdOpenData,
  OpenData: OpenData,
  UserName: UserName,
  PositionName: PositionName,
  DeptName: DeptName,
  WwOpenData: WwOpenData,
  OpenDataMatch: OpenDataMatch,
  OpenDataHtml: OpenDataHtml
};
export function install(Vue, config, component) {
  if (config === void 0) {
    config = {};
  }

  var registerings = component ? [component] : components; // 全局注册组件

  eachKey(registerings, function (cmpOptions) {
    Vue.component(cmpOptions.name, cmpOptions);
  }); // YxtbizUserName 等组件单独注册时，
  // 确保也注册 YxtbizOpenData YxtbizDdOpenData

  if (!Vue.component(OpenData.name)) {
    Vue.component(OpenData.name, OpenData);
    Vue.component(DdOpenData.name, DdOpenData);
  }

  ignoreElement(['dt-open-data', 'ww-open-data'], Vue); // 设置域名

  Api.setConfig(config);
  var isVue3 = Vue.version.split('.').shift() * 1 >= 3;

  if (isVue3) {
    if (!config.h) {
      var tips = "\n        Vue3.x \u9700\u4F20\u5165h\u65B9\u6CD5, \u5982\uFF1A\n        import { h } from 'vue'\n        import YxtOpenData from 'yxt-open-data'\n        app.use(YxtOpenData, {h, env, domain})";
      console.error(tips);
    }
  } else {
    if (config.h) {
      console.error('Vue2.x不需要传入h参数!');
    }
  }

  vueUtils.Vue = Vue;
  vueUtils.h = config.h;
  vueUtils.isVue3 = isVue3;

  vueUtils.h3 = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var type = args[0],
        props = args[1],
        others = args.slice(2); // props 扁平化
    // https://vue3js.cn/docs/zh/guide/migration/render-function-api.html#_3-x-%E8%AF%AD%E6%B3%95-3

    if (props.attrs) {
      Object.assign(props, props.attrs);
      delete props.attrs;
    } // vue3 h(componentOptions, ...)


    var app = vueUtils.Vue;
    var globalComponents = app._context ? app._context.components : {};
    var targetComponent = type;

    if (typeof type === 'string') {
      eachKey(globalComponents, function (cmp, name) {
        if (kabebCase(name) === kabebCase(type)) {
          targetComponent = cmp;
        }
      });
    }

    return vueUtils.h.apply(vueUtils, [targetComponent, props].concat(others));
  };

  decorateAttachShadow();
} // 每个组件添加 install 方法，可单独注册

eachKey(components, function (component) {
  component.install = function (Vue, config) {
    install(Vue, config, this);
  };
});
export default components;